module.exports = __webpack_public_path__ + "img/Clear Lab_Over.1f203264.svg";